import { ProductService } from 'src/app/angularJS/services/product/product.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

/**
 * A controller used to create new products on a catalogue
 */
export class ProductCreateController {
  private static $inject = [
    '$state',
    '$stateParams',
    '$rootScope',
    'productService',
    'UserMessages',
    'ACTToolbarService',
    'catalogueConstants'
  ];
  public required: InterACT.Interfaces.Catalogues.Product;
  public channelAvailableValues: Array<string>;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams,
    private $rootScope,
    private productService: ProductService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    private catalogueConstants: InterACT.Interfaces.ICatalogueConstants
  ) {
    this.activate();
  }

  /**
   * Creates a product by merging the data entered in the form with the required data
   * @param data the product data entered in the form
   * @returns a promise from the product service
   */
  public createProduct = (data: InterACT.Interfaces.Catalogues.Product) => {
    _.merge(data, this.required);
    this.$rootScope.showSpinner = true;
    return this.productService.create(this.$stateParams.catalogueId, data).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('TOAST_MESSAGE.PRODUCT.CREATED');
      return this.exitCreateProduct();
    });
  }

  /**
   * Exits the create product view to the product list view
   * @returns a promise from the state provider
   */
  public exitCreateProduct = () => {
    return this.$state.go('catalogue.product-list', {
      catalogueId: this.$stateParams.catalogueId,
      catalogueVersion: this.$stateParams.catalogueVersion
    });
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.required = <any>{};
    this.required.channels = [];
    this.required.tags = [];
    this.channelAvailableValues = this.catalogueConstants.CHANNELS;

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('HEADING.PRODUCT.CREATE');
    });
  }
}